import { render, staticRenderFns } from "./CreateUserForm.vue?vue&type=template&id=1aad37a8"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"
import style0 from "./CreateUserForm.vue?vue&type=style&index=0&id=1aad37a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports